import B2bLanding from "@/pages/B2bLanding";

export default function Home() {
  return <B2bLanding />;
}
